// Archivo: EntradasPendientes.jsx (gestiona entradas Y salidas pendientes CON LOTES)
import React, { useEffect, useState, useRef } from "react";
import api from "../services/api";
import { reproducirSonido, mostrarNotificacion, solicitarPermisoNotificaciones } from "../utils/notificationUtils.js";

const EntradasPendientes = () => {
  const [items, setItems] = useState([]); // Contendrá entradas y salidas
  const [loading, setLoading] = useState(true);
  const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });
  const [filtro, setFiltro] = useState("pendientes"); // "pendientes", "aprobadas", "rechazadas", "todas"
  const [modalDetalle, setModalDetalle] = useState(null);
  const [departamentos, setDepartamentos] = useState([]);
  const cantidadPendientesRef = useRef(0); // Para comparar cambios
  const [materialesLote, setMaterialesLote] = useState([]);
  const [procesandoLote, setProcesandoLote] = useState(false);

  // Solicitar permiso de notificaciones al cargar
  useEffect(() => {
    solicitarPermisoNotificaciones();
  }, []);

  

  // 🔄 Cargar entradas Y salidas CON AGRUPACIÓN DE LOTES
  const cargarItems = async (silencioso = false) => {
    try {
      if (!silencioso) setLoading(true);
      
      const [entradasRes, salidasRes] = await Promise.all([
        api.get('/entradas'),
        api.get('/salidas')
      ]);

 // 📦 AGRUPAR ENTRADAS POR LOTE
const entradas = entradasRes.data;
const entradasAgrupadas = [];
const lotesEntradaYaProcesados = new Set();

entradas.forEach(entrada => {
  // Si es parte de un lote de entrada y aún no lo procesamos
  if (entrada.es_lote && entrada.lote_entrada_id && !lotesEntradaYaProcesados.has(entrada.lote_entrada_id)) {
    // Buscar todas las entradas de este lote
    const entradasDelLote = entradas.filter(e => e.lote_entrada_id === entrada.lote_entrada_id);
    
    // ✅ DETERMINAR ESTADO DEL LOTE
    const tienePendientes = entradasDelLote.some(e => e.estado === 'pendiente_aprobacion');
    const estadoLote = tienePendientes ? 'pendiente_aprobacion' : 'aprobada';
    
    // Crear un objeto "lote" agrupado
    entradasAgrupadas.push({
      id: entrada.lote_entrada_id,
      tipo: 'entrada-lote',
      es_lote: true,
      lote_entrada_id: entrada.lote_entrada_id,
      numero_factura: entrada.numero_factura,
      proveedor: entrada.proveedor,
      fecha_adquisicion: entrada.fecha_adquisicion,
      responsable: entrada.responsable,
      estado: estadoLote,
      createdAt: entrada.createdAt,
      motivo_rechazo: entrada.motivo_rechazo,
      aprobado_por: entrada.aprobado_por,
      fecha_aprobacion: entrada.fecha_aprobacion,
      items: entradasDelLote.map(e => ({
        id: e.id,
        material_codigo: e.material?.codigo || e.codigo || 'N/A',
        material_nombre: e.material?.nombre || e.descripcion || 'Material desconocido',
        cantidad: e.cantidad,
        costo_unitario: e.costo_unitario,
        valor_total: e.valor_total,
        MaterialId: e.MaterialId
      })),
      cantidad_total: entradasDelLote.reduce((sum, e) => sum + e.cantidad, 0),
      valor_total: entradasDelLote.reduce((sum, e) => sum + parseFloat(e.valor_total || 0), 0),
      cantidad_items: entradasDelLote.length
    });
    
    lotesEntradaYaProcesados.add(entrada.lote_entrada_id);
  } 
  // Si NO tiene lote_entrada_id (entradas individuales)
  else if (!entrada.lote_entrada_id) {
    entradasAgrupadas.push({ ...entrada, tipo: 'entrada' });
  }
  // Si tiene lote_entrada_id pero ya fue procesado, no hacer nada
});

// 📦 AGRUPAR SALIDAS POR LOTE
const salidas = salidasRes.data;
const salidasAgrupadas = [];
const lotesYaProcesados = new Set();

salidas.forEach(salida => {
  // Si es parte de un lote y aún no lo procesamos
  if (salida.es_lote && salida.lote_grupo_id && !lotesYaProcesados.has(salida.lote_grupo_id)) {
    // Buscar todas las salidas de este lote
    const salidasDelLote = salidas.filter(s => s.lote_grupo_id === salida.lote_grupo_id);
    
    // ✅ DETERMINAR ESTADO DEL LOTE
    const tienePendientes = salidasDelLote.some(s => s.estado === 'pendiente_aprobacion');
    const todasRechazadas = salidasDelLote.every(s => s.estado === 'rechazada');
    const estadoLote = tienePendientes? 'pendiente_aprobacion': todasRechazadas? 'rechazada': 'aprobada';
    
    // Crear un objeto "lote" agrupado
    salidasAgrupadas.push({
      id: salida.lote_grupo_id,
      tipo: 'salida-lote',
      es_lote: true,
      lote_grupo_id: salida.lote_grupo_id,
      fecha: salida.fecha,
      departamento_id: salida.departamento_id,
      responsable: salida.responsable,
      observacion: salida.observacion,
      estado: estadoLote,
      usuario_solicitante: salida.usuario_solicitante,
      createdAt: salida.createdAt,
      motivo_rechazo: salida.motivo_rechazo,
      aprobado_por: salida.aprobado_por,
      fecha_aprobacion: salida.fecha_aprobacion,
      proyecto: salida.proyecto,
      almacen_origen: salida.almacen_origen,
      Departamento: salida.Departamento,
      AlmacenOrigenId: salida.AlmacenOrigenId,
      proyectoId: salida.proyectoId,
      items: salidasDelLote.map(s => ({
        id: s.id,
        material_codigo: s.material?.codigo || 'N/A',
        material_nombre: s.material?.nombre || 'Material desconocido',
        cantidad: s.cantidad,
        MaterialId: s.MaterialId
      })),
      cantidad_total: salidasDelLote.reduce((sum, s) => sum + s.cantidad, 0),
      cantidad_items: salidasDelLote.length
    });
    
    lotesYaProcesados.add(salida.lote_grupo_id);
  } 
  // Si NO es parte de un lote, agregar normalmente
  else if (!salida.es_lote || !salida.lote_grupo_id) {
    salidasAgrupadas.push({ ...salida, tipo: 'salida' });
  }
});

const todos = [...entradasAgrupadas, ...salidasAgrupadas]
  .filter(item => item.estado !== undefined && item.estado !== null);

      // Detectar nuevas entradas/salidas pendientes
      const pendientesActuales = todos.filter(i => i.estado === "pendiente_aprobacion").length;
      
      if (cantidadPendientesRef.current > 0 && pendientesActuales > cantidadPendientesRef.current) {
        // HAY NUEVAS PENDIENTES
        const cantidadNuevas = pendientesActuales - cantidadPendientesRef.current;
        reproducirSonido();
        mostrarNotificacion(
          "🔔 Nueva Aprobación Pendiente",
          `Tienes ${cantidadNuevas} movimiento(s) pendiente(s) de aprobar`
        );
      }
      
      cantidadPendientesRef.current = pendientesActuales;
      setItems(todos);
    } catch (error) {
      console.error("❌ Error al cargar entradas/salidas:", error);
      if (!silencioso) {
        setMensaje({ texto: "❌ Error al cargar datos", tipo: "error" });
      }
    } finally {
      if (!silencioso) setLoading(false);
    }
  };

  // Cargar departamentos
  const cargarDepartamentos = async () => {
    try {
      const res = await api.get('/departamentos');
      setDepartamentos(res.data);
    } catch (error) {
      console.error("Error al cargar departamentos:", error);
    }
  };

  // Función para obtener nombre del departamento
  const getNombreDepartamento = (departamento_id) => {
    if (!departamento_id) return '—';
    const dept = departamentos.find(d => d.id === departamento_id);
    return dept ? dept.nombre : `Dept. ${departamento_id}`;
  };

  // ✅ AGREGAR ESTAS FUNCIONES ANTES DE aprobarItem

const toggleMaterial = (materialId) => {
  setMaterialesLote(prev => prev.map(mat => 
    mat.id === materialId 
      ? { ...mat, seleccionado: !mat.seleccionado }
      : mat
  ));
};

const actualizarCantidad = (materialId, nuevaCantidad) => {
  const cantidad = Math.max(0, parseInt(nuevaCantidad) || 0);
  setMaterialesLote(prev => prev.map(mat => 
    mat.id === materialId 
      ? { ...mat, cantidad_aprobada: cantidad }
      : mat
  ));
};

const toggleTodos = () => {
  const todosSeleccionados = materialesLote.every(mat => mat.seleccionado);
  setMaterialesLote(prev => prev.map(mat => ({
    ...mat,
    seleccionado: !todosSeleccionados
  })));
};

const aprobarLoteParcial = async () => {
  setProcesandoLote(true);
  
  try {
    const materiales = materialesLote.map(mat => ({
      salida_id: mat.id,
      accion: mat.seleccionado ? 'aprobar' : 'rechazar',
      cantidad_aprobada: mat.seleccionado ? mat.cantidad_aprobada : undefined,
      motivo_rechazo: !mat.seleccionado ? 'No seleccionado por el supervisor' : undefined
    }));
    console.log('📦 Datos enviados al backend:');
    console.log('Lote grupo ID:', modalDetalle.lote_grupo_id);
    console.log('Materiales:', materiales);
    console.log('Estado de materialesLote:', materialesLote);


    const response = await api.put(
      `/salidas/lotes/${modalDetalle.lote_grupo_id}/aprobar-parcial`,
      { materiales }
    );

    setMensaje({
      texto: response.data.mensaje || "✅ Lote procesado correctamente",
      tipo: "exito",
    });

    setModalDetalle(null);
    setMaterialesLote([]);
    await cargarItems(true);

  } catch (error) {
    console.error("Error al aprobar lote:", error);
    setMensaje({
      texto: error.response?.data?.mensaje || "❌ Error al procesar el lote",
      tipo: "success",
    });
  } finally {
    setProcesandoLote(false);
  }
};

 const aprobarItem = async (item) => {
  const esLoteSalida = item.tipo === 'salida-lote';
  const esLoteEntrada = item.tipo === 'entrada-lote';
  const esLote = esLoteSalida || esLoteEntrada;
  
  const tipoTexto = item.tipo === 'entrada' 
    ? 'entrada' 
    : item.tipo === 'entrada-lote'
    ? 'lote de entradas'
    : esLoteSalida 
    ? 'lote de salidas' 
    : 'salida';
  
  if (!window.confirm(`¿Está seguro de aprobar esta ${tipoTexto}?${esLote ? ` (${item.cantidad_items} materiales)` : ''}`)) 
    return;

  try {
    let endpoint;
    
    if (item.tipo === 'entrada') {
      endpoint = `/entradas/aprobar/${item.id}`;
    } else if (item.tipo === 'entrada-lote') {
      endpoint = `/entradas/lote/aprobar/${item.lote_entrada_id}`;
    } else if (esLoteSalida) {
      endpoint = `/salidas/lote/aprobar/${item.lote_grupo_id}`;
    } else {
      endpoint = `/salidas/aprobar/${item.id}`;
    }
      
      await api.put(endpoint);
      setMensaje({ 
        texto: `✅ ${tipoTexto.charAt(0).toUpperCase() + tipoTexto.slice(1)} aprobada correctamente`, 
        tipo: "success" 
      });
      cargarItems();
      setModalDetalle(null);
      setTimeout(() => setMensaje({ texto: "", tipo: "" }), 3000);
    } catch (error) {
      console.error("Error al aprobar:", error);
      console.error("📛 Respuesta completa del servidor:", error.response?.data);
      setMensaje({ 
        texto: "❌ " + (error.response?.data?.mensaje || `Error al aprobar ${tipoTexto}`), 
        tipo: "error" 
      });
    }
  };

  // ❌ Rechazar (dinámico según tipo CON SOPORTE PARA LOTES)
  const rechazarItem = async (item) => {
    const motivo = window.prompt("Ingrese el motivo del rechazo:");
    if (!motivo) return;

    const esLote = item.tipo === 'salida-lote';

    try {
      let endpoint;
      
      if (item.tipo === 'entrada') {
        endpoint = `/entradas/rechazar/${item.id}`;
      } else if (esLote) {
        endpoint = `/salidas/lote/rechazar/${item.lote_grupo_id}`;
      } else {
        endpoint = `/salidas/rechazar/${item.id}`;
      }
      
      await api.put(endpoint, { motivo });
      setMensaje({ 
        texto: `✅ ${item.tipo === 'entrada' ? 'Entrada' : (esLote ? 'Lote' : 'Salida')} rechazada`, 
        tipo: "success" 
      });
      cargarItems();
      setModalDetalle(null);
      setTimeout(() => setMensaje({ texto: "", tipo: "" }), 3000);
    } catch (error) {
      console.error("Error al rechazar:", error);
      setMensaje({ texto: "❌ Error al rechazar", tipo: "error" });
    }
  };

  const verDetalle = (item) => {
  setModalDetalle(item);
  
  // Si es un lote pendiente, inicializar estado de materiales
  if (item.tipo === 'salida-lote' && item.estado === 'pendiente_aprobacion') {
    const materialesIniciales = item.items.map(mat => ({
      id: mat.id,
      material_codigo: mat.material_codigo,
      material_nombre: mat.material_nombre,
      cantidad_solicitada: mat.cantidad,
      cantidad_aprobada: mat.cantidad,
      seleccionado: true,
      accion: 'aprobar'
    }));
    setMaterialesLote(materialesIniciales);
  }
};

  
  
  const cerrarModal = () => setModalDetalle(null);

  // 🔍 Filtrar items según estado y tipo
  const itemsFiltrados = () => {
    let filtrados = items;

    if (filtro === "pendientes") {
      filtrados = items.filter(i => i.estado === "pendiente_aprobacion");
    } else if (filtro === "aprobadas") {
      filtrados = items.filter(i => i.estado === "aprobada");
    } else if (filtro === "rechazadas") {
      filtrados = items.filter(i => i.estado === "rechazada");
    }

    return filtrados;
  };

  const getEstadoBadge = (estado) => {
    switch (estado) {
      case "pendiente_aprobacion":
        return { bg: "#fef3c7", color: "#78350f", icon: "⏳", texto: "PENDIENTE" };
      case "aprobada":
        return { bg: "#d1fae5", color: "#065f46", icon: "✅", texto: "APROBADA" };
      case "rechazada":
        return { bg: "#fee2e2", color: "#991b1b", icon: "❌", texto: "RECHAZADA" };
      default:
        return { bg: "#f3f4f6", color: "#374151", icon: "📋", texto: estado?.toUpperCase() || "N/A" };
    }
  };

const getTipoBadge = (tipo) => {
  if (tipo === 'entrada') {
    return { texto: '📥 ENTRADA', bg: '#dbeafe', color: '#1d4ed8' };
  } else if (tipo === 'entrada-lote') {
    return { texto: '📦 LOTE ENTRADA', bg: '#dcfce7', color: '#166534' };
  } else if (tipo === 'salida-lote') {
    return { texto: '📦 LOTE SALIDA', bg: '#fecaca', color: '#991b1b' };
  } else {
    return { texto: '📤 SALIDA', bg: '#fee2e2', color: '#b91c1c' };
  }
};

  useEffect(() => {
    cargarItems();
    cargarDepartamentos();

    // Polling cada 30 segundos para verificar nuevas aprobaciones
    const intervalo = setInterval(() => {
      cargarItems(true); // true = silencioso (sin loader)
    }, 30000); // 30 segundos

    return () => clearInterval(intervalo); // Limpiar al desmontar
  }, []);

  // Estadísticas
  const estadisticas = {
    total: items.length,
    pendientes: items.filter(i => i.estado === "pendiente_aprobacion").length,
    aprobadas: items.filter(i => i.estado === "aprobada").length,
    rechazadas: items.filter(i => i.estado === "rechazada").length,
    entradas: items.filter(i => i.tipo === "entrada").length,
    salidas: items.filter(i => i.tipo === "salida" || i.tipo === "salida-lote").length,
  };

  const fechaLimpia = (f) => {
    if (!f) return "N/A";
    return f.split("T")[0].split("-").reverse().join("/");
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>📋 Gestión de Movimientos</h1>
          <p style={styles.subtitle}>Supervisión y aprobación de entradas y salidas del inventario</p>
        </div>
      </div>

      {/* Estadísticas */}
      <div style={styles.statsContainer}>
        <div style={{...styles.statCard, borderLeft: "4px solid #6366f1"}}>
          <div style={styles.statIcon}>📦</div>
          <div>
            <div style={styles.statValue}>{estadisticas.total}</div>
            <div style={styles.statLabel}>Total Movimientos</div>
          </div>
        </div>

        <div style={{...styles.statCard, borderLeft: "4px solid #f59e0b"}}>
          <div style={styles.statIcon}>📥</div>
          <div>
            <div style={styles.statValue}>{estadisticas.entradas}</div>
            <div style={styles.statLabel}>Entradas</div>
          </div>
        </div>

        <div style={{...styles.statCard, borderLeft: "4px solid #ef4444"}}>
          <div style={styles.statIcon}>📤</div>
          <div>
            <div style={styles.statValue}>{estadisticas.salidas}</div>
            <div style={styles.statLabel}>Salidas</div>
          </div>
        </div>

        <div style={{...styles.statCard, borderLeft: "4px solid #10b981"}}>
          <div style={styles.statIcon}>✅</div>
          <div>
            <div style={styles.statValue}>{estadisticas.aprobadas}</div>
            <div style={styles.statLabel}>Aprobadas</div>
          </div>
        </div>
      </div>

      {/* Filtros */}
      <div style={styles.filtrosContainer}>
        <button 
          style={{...styles.filtroBtn, ...(filtro === "todas" && styles.filtroBtnActive)}}
          onClick={() => setFiltro("todas")}
        >
          Todas ({estadisticas.total})
        </button>
        <button 
          style={{...styles.filtroBtn, ...(filtro === "pendientes" && styles.filtroBtnActive)}}
          onClick={() => setFiltro("pendientes")}
        >
          ⏳ Pendientes ({estadisticas.pendientes})
        </button>
        <button 
          style={{...styles.filtroBtn, ...(filtro === "aprobadas" && styles.filtroBtnActive)}}
          onClick={() => setFiltro("aprobadas")}
        >
          ✅ Aprobadas ({estadisticas.aprobadas})
        </button>
        <button 
          style={{...styles.filtroBtn, ...(filtro === "rechazadas" && styles.filtroBtnActive)}}
          onClick={() => setFiltro("rechazadas")}
        >
          ❌ Rechazadas ({estadisticas.rechazadas})
        </button>
      </div>

      {/* Mensaje */}
      {mensaje.texto && (
        <div style={{
          ...styles.message,
          ...(mensaje.tipo === "success" ? styles.messageSuccess : styles.messageError)
        }}>
          {mensaje.texto}
        </div>
      )}

      {/* Tabla */}
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>Movimientos Registrados ({itemsFiltrados().length})</h2>

        {loading ? (
          <div style={styles.loadingMessage}>⏳ Cargando movimientos...</div>
        ) : itemsFiltrados().length === 0 ? (
          <div style={styles.emptyMessage}>
            📭 No hay {filtro === "todas" ? "movimientos" : `movimientos ${filtro}`} registrados
            <br />
            <small>Los movimientos aparecerán aquí una vez sean registrados</small>
          </div>
        ) : (
          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHeaderRow}>
                  <th style={styles.th}>Tipo</th>
                  <th style={styles.th}>Fecha</th>
                  <th style={styles.th}>Material / Departamento</th>
                  <th style={styles.th}>Cantidad</th>
                  <th style={styles.th}>Responsable</th>
                  <th style={styles.th}>Estado</th>
                  <th style={styles.th}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {itemsFiltrados().map((item) => {
                  const tipoBadge = getTipoBadge(item.tipo);
                  const estadoBadge = getEstadoBadge(item.estado);
                 const esLoteSalida = item.tipo === 'salida-lote';
const esLoteEntrada = item.tipo === 'entrada-lote';
const esLote = esLoteSalida || esLoteEntrada;

return (
  <tr key={`${item.tipo}-${item.id}`} style={styles.tr}>
    <td style={styles.td}>
      <span style={{
        ...styles.badge,
        background: tipoBadge.bg,
        color: tipoBadge.color
      }}>
        {tipoBadge.texto}
      </span>
    </td>
    <td style={styles.td}>{fechaLimpia(item.fecha || item.fecha_adquisicion)}</td>
    <td style={styles.td}>
      {item.tipo === 'entrada' 
        ? item.material?.nombre || "N/A"
        : esLoteEntrada
        ? `${item.cantidad_items} materiales — ${item.proveedor || 'Proveedor'}`
        : esLoteSalida
        ? `${item.cantidad_items} materiales → ${getNombreDepartamento(item.departamento_id)}`
        : `${item.material?.nombre || "N/A"} → ${getNombreDepartamento(item.departamento_id)}`
      }
    </td>
    <td style={styles.tdNum}>
      {esLote ? `${item.cantidad_total} (${item.cantidad_items} items)` : item.cantidad}
    </td>
                      <td style={styles.td}>{item.responsable || item.proveedor || "—"}</td>
                      <td style={styles.td}>
                        <span style={{
                          ...styles.badge,
                          background: estadoBadge.bg,
                          color: estadoBadge.color
                        }}>
                          {estadoBadge.icon} {estadoBadge.texto}
                        </span>
                      </td>
                      <td style={styles.tdActions}>
                        <button 
                          style={styles.btnVer}
                          onClick={() => verDetalle(item)}
                          title="Ver detalles"
                        >
                          👁️ Ver
                        </button>
                        {item.estado === "pendiente_aprobacion" && (
                          <>
                            <button
                              style={styles.btnAprobar}
                              onClick={() => aprobarItem(item)}
                              title="Aprobar"
                            >
                              ✅
                            </button>
                            <button
                              style={styles.btnRechazar}
                              onClick={() => rechazarItem(item)}
                              title="Rechazar"
                            >
                              ❌
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal de Detalle */}
      {modalDetalle && (
        <div style={styles.modalOverlay} onClick={cerrarModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>
               {modalDetalle.tipo === 'entrada' ? '📥 Detalle de Entrada' : 
 modalDetalle.tipo === 'entrada-lote' ? '📦 Detalle de Lote de Entradas' :
 modalDetalle.tipo === 'salida-lote' ? '📦 Detalle de Lote de Salidas' : 
 '📤 Detalle de Salida'}
              </h2>
              <button style={styles.btnCerrar} onClick={cerrarModal}>✕</button>
            </div>

            <div style={styles.modalBody}>
              <div style={styles.detalleGrid}>
                <div style={styles.detalleItem}>
                  <span style={styles.detalleLabel}>Tipo</span>
                  <span style={styles.detalleValue}>
                    {getTipoBadge(modalDetalle.tipo).texto}
                  </span>
                </div>

                <div style={styles.detalleItem}>
                  <span style={styles.detalleLabel}>Estado</span>
                  <span style={styles.detalleValue}>
                    {getEstadoBadge(modalDetalle.estado).icon} {getEstadoBadge(modalDetalle.estado).texto}
                  </span>
                </div>

                <div style={styles.detalleItem}>
                  <span style={styles.detalleLabel}>Fecha</span>
                  <span style={styles.detalleValue}>
                    {fechaLimpia(modalDetalle.fecha || modalDetalle.fecha_adquisicion)}
                  </span>
                </div>

                {modalDetalle.tipo === 'entrada' ? (
                  <>
                    <div style={styles.detalleItem}>
                      <span style={styles.detalleLabel}>Material</span>
                      <span style={styles.detalleValue}>{modalDetalle.material?.nombre || "N/A"}</span>
                    </div>

                    <div style={styles.detalleItem}>
                      <span style={styles.detalleLabel}>Cantidad</span>
                      <span style={styles.detalleValue}>{modalDetalle.cantidad}</span>
                    </div>

                    <div style={styles.detalleItem}>
                      <span style={styles.detalleLabel}>Proveedor</span>
                      <span style={styles.detalleValue}>{modalDetalle.proveedor || "—"}</span>
                    </div>

                    <div style={styles.detalleItem}>
                      <span style={styles.detalleLabel}>Precio Unitario</span>
                      <span style={styles.detalleValue}>
                        RD$ {parseFloat(modalDetalle.precio_unitario || 0).toFixed(2)}
                      </span>
                    </div>

                    <div style={styles.detalleItem}>
                      <span style={styles.detalleLabel}>Costo Total</span>
                      <span style={styles.detalleValue}>
                        RD$ {parseFloat(modalDetalle.costo_total || 0).toFixed(2)}
                      </span>
                    </div>
                  </>

  ) : modalDetalle.tipo === 'entrada-lote' ? (
  <>
    {/* Información del lote de entradas */}
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Factura</span>
      <span style={styles.detalleValue}>{modalDetalle.numero_factura || 'N/A'}</span>
    </div>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Proveedor</span>
      <span style={styles.detalleValue}>{modalDetalle.proveedor || 'N/A'}</span>
    </div>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Total Materiales</span>
      <span style={styles.detalleValue}>{modalDetalle.cantidad_items}</span>
    </div>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Cantidad Total</span>
      <span style={styles.detalleValue}>{modalDetalle.cantidad_total}</span>
    </div>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Valor Total</span>
      <span style={styles.detalleValue}>
        RD$ {parseFloat(modalDetalle.valor_total || 0).toFixed(2)}
      </span>
    </div>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Fecha</span>
      <span style={styles.detalleValue}>
        {fechaLimpia(modalDetalle.fecha_adquisicion)}
      </span>
    </div>

    {/* Tabla de materiales del lote */}
    <div style={{...styles.detalleItem, gridColumn: '1 / -1'}}>
      <span style={styles.detalleLabel}>Materiales del Lote:</span>
      <div style={{ marginTop: '10px' }}>
        <table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8fafc' }}>
              <th style={{ padding: '8px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>
                Código
              </th>
              <th style={{ padding: '8px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>
                Material
              </th>
              <th style={{ padding: '8px', textAlign: 'right', borderBottom: '2px solid #e2e8f0' }}>
                Cantidad
              </th>
              <th style={{ padding: '8px', textAlign: 'right', borderBottom: '2px solid #e2e8f0' }}>
                Costo Unit.
              </th>
              <th style={{ padding: '8px', textAlign: 'right', borderBottom: '2px solid #e2e8f0' }}>
                Valor Total
              </th>
            </tr>
          </thead>
          <tbody>
            {modalDetalle.items?.map((item, idx) => (
              <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td style={{ padding: '8px' }}>
                  <strong>{item.material_codigo}</strong>
                </td>
                <td style={{ padding: '8px' }}>{item.material_nombre}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>
                  <strong>{item.cantidad}</strong>
                </td>
                <td style={{ padding: '8px', textAlign: 'right' }}>
                  RD$ {parseFloat(item.costo_unitario || 0).toFixed(2)}
                </td>
                <td style={{ padding: '8px', textAlign: 'right' }}>
                  RD$ {parseFloat(item.valor_total || 0).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </>
) : modalDetalle.tipo === 'salida-lote' ? (
  <>
    {/* Información del lote de salidas */}
    {/* Proyecto - NUEVO CON ESTILO AZUL */}
    {modalDetalle.proyecto && (
      <div style={styles.detalleItem}>
        <span style={styles.detalleLabel}>Proyecto</span>
        <span style={{
          ...styles.detalleValue,
          background: '#dbeafe',
          color: '#1d4ed8',
          padding: '8px 16px',
          borderRadius: '8px',
          fontWeight: '600',
          display: 'inline-block'
        }}>
          🏗️ {modalDetalle.proyecto.nombre}
        </span>
      </div>
    )}

    {/* Almacén */}
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Almacén</span>
     <span style={styles.detalleValue}>
  {modalDetalle.almacen_origen?.nombre || '—'}
</span>
    </div>

    {/* Departamento */}
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Departamento</span>
      <span style={styles.detalleValue}>
        {getNombreDepartamento(modalDetalle.departamento_id)}
      </span>
    </div>

    {/* Responsable */}
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Responsable</span>
      <span style={styles.detalleValue}>{modalDetalle.responsable || "—"}</span>
    </div>

    {/* Total de Materiales */}
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Total de Materiales</span>
      <span style={styles.detalleValue}>{modalDetalle.cantidad_items} items</span>
    </div>

    {/* Cantidad Total */}
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Cantidad Total</span>
      <span style={styles.detalleValue}>{modalDetalle.cantidad_total}</span>
    </div>

 {/* Tabla de materiales del lote CON EDICIÓN */}
<div style={{...styles.detalleItem, gridColumn: '1 / -1'}}>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
    <span style={styles.detalleLabel}>Materiales del Lote</span>
    {modalDetalle.estado === 'pendiente_aprobacion' && (
      <button 
        onClick={toggleTodos}
        style={{
          padding: '4px 12px',
          fontSize: '12px',
          background: '#e0e7ff',
          color: '#4338ca',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: '600'
        }}
      >
        {materialesLote.every(m => m.seleccionado) ? '☐ Deseleccionar Todos' : '☑ Seleccionar Todos'}
      </button>
    )}
  </div>
  
  <div style={{ marginTop: '10px', overflowX: 'auto' }}>
    <table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ background: '#f8fafc' }}>
          {modalDetalle.estado === 'pendiente_aprobacion' && (
            <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #e2e8f0', width: '40px' }}>✓</th>
          )}
          <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Código</th>
          <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Material</th>
          <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Solicitado</th>
          {modalDetalle.estado === 'pendiente_aprobacion' && (
            <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Aprobar</th>
          )}
        </tr>
      </thead>
      <tbody>
        {modalDetalle.estado === 'pendiente_aprobacion' ? (
          materialesLote.map((mat, idx) => (
            <tr key={idx} style={{ 
              background: mat.seleccionado ? '#ffffff' : '#fef2f2',
              opacity: mat.seleccionado ? 1 : 0.6
            }}>
              <td style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #f1f5f9' }}>
                <input 
                  type="checkbox" 
                  checked={mat.seleccionado}
                  onChange={() => toggleMaterial(mat.id)}
                  style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#4f46e5' }}
                />
              </td>
              <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9', fontWeight: '500' }}>
                {mat.material_codigo}
              </td>
              <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9' }}>
                {mat.material_nombre}
              </td>
              <td style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #f1f5f9', fontWeight: '600' }}>
                {mat.cantidad_solicitada}
              </td>
              <td style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #f1f5f9' }}>
                {mat.seleccionado ? (
                  <input 
                    type="number"
                    min="0"
                    max={mat.cantidad_solicitada}
                    value={mat.cantidad_aprobada}
                    onChange={(e) => actualizarCantidad(mat.id, e.target.value)}
                    style={{
                      width: '80px',
                      padding: '6px 10px',
                      border: '2px solid #e0e7ff',
                      borderRadius: '6px',
                      fontSize: '14px',
                      fontWeight: '600',
                      textAlign: 'center'
                    }}
                  />
                ) : (
                  <span style={{ color: '#991b1b', fontWeight: '600' }}>—</span>
                )}
              </td>
            </tr>
          ))
        ) : (
          modalDetalle.items?.map((item, idx) => (
            <tr key={idx}>
              <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9', fontWeight: '500' }}>
                {item.material_codigo}
              </td>
              <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9' }}>
                {item.material_nombre}
              </td>
              <td style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #f1f5f9', fontWeight: '600' }}>
                {item.cantidad}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
  
  {modalDetalle.estado === 'pendiente_aprobacion' && (
    <div style={{
      marginTop: '12px',
      padding: '12px',
      background: '#f0fdf4',
      border: '1px solid #86efac',
      borderRadius: '8px',
      fontSize: '13px'
    }}>
      <strong>📊 Resumen:</strong> {materialesLote.filter(m => m.seleccionado).length} materiales seleccionados
    </div>
  )}
</div>
  </>
) : (
                  <>
                  {/* ✅ AGREGAR: Proyecto */}
{modalDetalle.proyecto && (
  <div style={styles.detalleItem}>
    <span style={styles.detalleLabel}>Proyecto</span>
    <span style={{
      ...styles.detalleValue,
      background: '#dbeafe',
      color: '#1d4ed8',
      padding: '8px 16px',
      borderRadius: '8px',
      fontWeight: '600',
      display: 'inline-block'
    }}>
      🏗️ {modalDetalle.proyecto.nombre}
    </span>
  </div>
)}
{/* ✅ AGREGAR: Almacén */}
{modalDetalle.almacen_origen && (
  <div style={styles.detalleItem}>
    <span style={styles.detalleLabel}>Almacén</span>
    <span style={styles.detalleValue}>
      {modalDetalle.almacen_origen.nombre}
    </span>
  </div>
)}



                    <div style={styles.detalleItem}>
                      <span style={styles.detalleLabel}>Material</span>
                      <span style={styles.detalleValue}>{modalDetalle.material?.nombre || "N/A"}</span>
                    </div>

                    <div style={styles.detalleItem}>
                      <span style={styles.detalleLabel}>Cantidad</span>
                      <span style={styles.detalleValue}>{modalDetalle.cantidad}</span>
                    </div>

                    <div style={styles.detalleItem}>
                      <span style={styles.detalleLabel}>Departamento</span>
                      <span style={styles.detalleValue}>
                        {getNombreDepartamento(modalDetalle.departamento_id)}
                      </span>
                    </div>

                    <div style={styles.detalleItem}>
                      <span style={styles.detalleLabel}>Responsable</span>
                      <span style={styles.detalleValue}>{modalDetalle.responsable || "—"}</span>
                    </div>
                  </>
                )}

                <div style={{...styles.detalleItem, gridColumn: '1 / -1'}}>
                  <span style={styles.detalleLabel}>Observaciones</span>
                  <span style={styles.detalleValue}>
                    {modalDetalle.observacion || "Sin observaciones"}
                  </span>
                </div>

                {modalDetalle.estado === "rechazada" && modalDetalle.motivo_rechazo && (
                  <div style={{...styles.detalleItem, gridColumn: '1 / -1'}}>
                    <span style={styles.detalleLabel}>Motivo de Rechazo</span>
                    <span style={{...styles.detalleValue, color: '#991b1b'}}>
                      {modalDetalle.motivo_rechazo}
                    </span>
                  </div>
                )}

                {modalDetalle.usuario_solicitante && (
                  <div style={styles.detalleItem}>
                    <span style={styles.detalleLabel}>Solicitante</span>
                    <span style={styles.detalleValue}>{modalDetalle.usuario_solicitante}</span>
                  </div>
                )}

                {modalDetalle.aprobado_por && (
                  <div style={styles.detalleItem}>
                    <span style={styles.detalleLabel}>Aprobado por</span>
                    <span style={styles.detalleValue}>{modalDetalle.aprobado_por}</span>
                  </div>
                )}
              </div>

             {modalDetalle.estado === "pendiente_aprobacion" && (
  <div style={styles.modalActions}>
    {modalDetalle.tipo === 'salida-lote' ? (
      <>
        <button
          style={styles.btnModalRechazar}
          onClick={() => rechazarItem(modalDetalle)}
          disabled={procesandoLote}
        >
          ❌ Rechazar Todo
        </button>
        <button
          style={{
            ...styles.btnModalAprobar,
            opacity: procesandoLote ? 0.6 : 1,
            cursor: procesandoLote ? 'not-allowed' : 'pointer'
          }}
          onClick={aprobarLoteParcial}
          disabled={procesandoLote || !materialesLote.some(m => m.seleccionado)}
        >
          {procesandoLote ? '⏳ Procesando...' : '✅ Aprobar Seleccionados'}
        </button>
      </>
    ) : (
      <>
        <button
          style={styles.btnModalRechazar}
          onClick={() => rechazarItem(modalDetalle)}
        >
          ❌ Rechazar
        </button>
        <button
          style={styles.btnModalAprobar}
          onClick={() => aprobarItem(modalDetalle)}
        >
          ✅ Aprobar
        </button>
      </>
    )}
  </div>
)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Estilos (sin cambios)
const styles = {
  container: {
    padding: '20px',
    maxWidth: '1400px',
    margin: '0 auto',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    marginBottom: '30px',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 8px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: 0,
  },
  statsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    marginBottom: '30px',
  },
  statCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
  },
  statIcon: {
    fontSize: '32px',
  },
  statValue: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
  },
  statLabel: {
    fontSize: '12px',
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  filtrosContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  filtroBtn: {
    padding: '10px 20px',
    background: 'white',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#64748b',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  filtroBtnActive: {
    background: '#3b82f6',
    borderColor: '#3b82f6',
    color: 'white',
  },
  message: {
    marginBottom: '20px',
    padding: '12px 20px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'center',
  },
  messageSuccess: {
    background: '#d1fae5',
    color: '#065f46',
    border: '1px solid #10b981',
  },
  messageError: {
    background: '#fee2e2',
    color: '#991b1b',
    border: '1px solid #ef4444',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '30px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 20px 0',
  },
  loadingMessage: {
    textAlign: 'center',
    padding: '40px',
    fontSize: '16px',
    color: '#64748b',
  },
  emptyMessage: {
    textAlign: 'center',
    padding: '40px',
    fontSize: '16px',
    color: '#64748b',
    background: '#f8fafc',
    borderRadius: '8px',
    lineHeight: '1.8',
  },
  tableContainer: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
  },
  tableHeaderRow: {
    background: '#1e293b',
    color: 'white',
  },
  th: {
    padding: '12px 8px',
    textAlign: 'left',
    fontWeight: '600',
    borderBottom: '2px solid #cbd5e1',
  },
  tr: {
    borderBottom: '1px solid #e2e8f0',
    transition: 'background 0.2s',
  },
  td: {
    padding: '10px 8px',
    color: '#475569',
  },
  tdNum: {
    padding: '10px 8px',
    color: '#475569',
    textAlign: 'right',
  },
  tdActions: {
    padding: '10px 8px',
    display: 'flex',
    gap: '5px',
    justifyContent: 'center',
  },
  badge: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: '600',
  },
  btnVer: {
    padding: '6px 12px',
    background: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  btnAprobar: {
    padding: '6px 10px',
    background: '#10b981',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  btnRechazar: {
    padding: '6px 10px',
    background: '#ef4444',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalContent: {
    background: 'white',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '700px',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 30px',
    borderBottom: '1px solid #e2e8f0',
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#1e293b',
    margin: 0,
  },
  btnCerrar: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    color: '#64748b',
    cursor: 'pointer',
    padding: '0',
    width: '30px',
    height: '30px',
  },
  modalBody: {
    padding: '30px',
  },
  detalleGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '20px',
    marginBottom: '30px',
  },
  detalleItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  detalleLabel: {
    fontSize: '12px',
    color: '#64748b',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  detalleValue: {
    fontSize: '15px',
    color: '#1e293b',
    fontWeight: '500',
  },
  modalActions: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    paddingTop: '20px',
    borderTop: '1px solid #e2e8f0',
  },
  btnModalAprobar: {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
    transition: 'all 0.2s',
  },
  btnModalRechazar: {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
    transition: 'all 0.2s',
  },
};

export default EntradasPendientes;